import GetStartedCTABlock from "./GetStartedCTABlock";

export * from "./GetStartedCTABlock";
export default GetStartedCTABlock;
